const data = {
	"width": 24,
	"height": 24,
	"body": "<g id=\"evaEyeOff2Outline0\"><g id=\"evaEyeOff2Outline1\"><path id=\"evaEyeOff2Outline2\" fill=\"currentColor\" d=\"M17.81 13.39A8.93 8.93 0 0 0 21 7.62a1 1 0 1 0-2-.24a7.07 7.07 0 0 1-14 0a1 1 0 1 0-2 .24a8.93 8.93 0 0 0 3.18 5.77l-2.3 2.32a1 1 0 0 0 1.41 1.41l2.61-2.6a9.06 9.06 0 0 0 3.1.92V19a1 1 0 0 0 2 0v-3.56a9.06 9.06 0 0 0 3.1-.92l2.61 2.6a1 1 0 0 0 1.41-1.41Z\"/></g></g>"
};
exports.__esModule = true;
exports.default = data;
